import { clamp } from 'lodash';
import { AppThunk } from '../../../store/rootReducer';
import * as navigationActions from '../actions/navigation.actions';
import {
  activeSelector,
  maxTimestampSelector,
  minTimestampSelector,
  offsetSelector,
  timestampSelector,
} from '../selectors/navigation.selectors';

export const navigateTo = (timestamp: number): AppThunk => async (
  dispatch,
  getState,
) => {
  const navigationActive = activeSelector(getState());
  const currentTimestamp = timestampSelector(getState());
  const offset = offsetSelector(getState());
  const min = minTimestampSelector(getState());
  const max = maxTimestampSelector(getState());

  const newTimestamp = clamp(timestamp - offset, min, max);

  if (navigationActive && newTimestamp !== currentTimestamp) {
    dispatch(
      navigationActions.setTimestamp({
        timestamp: newTimestamp,
        meta: { history: false },
      }),
    );
  }
};
